<main class="mat-body" *ngIf="selectedProduct">
    <div class="container">
        <div class="row">
            <div class="col-12 pt-3">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'operative.meeting-details'|translate">
                        </h1>
                    </div>
                    <div class="col-auto">
                        {{ 'operative.contract-code'|translate }}
                        <strong class="text-blue">{{ contract.bankCode }}</strong>
                    </div>
                </div>
                <hr class="mt-1 mb-3" />

                <div class="row">
                    <div class="col-12 col-sm-5">
                        <label>{{ 'product.order'|translate }}</label>
                        <h2 class="mat-title text-blue font-weight-bold mb-0" [ngSwitch]="selectedProduct.order.type">
                            <ng-container *ngSwitchCase="OrderType.EXTERNAL_TRANSFER">{{
                                'form.order-type.external-transfer'|translate }}</ng-container>
                            <ng-container *ngSwitchCase="OrderType.INTERNAL_TRANSFER">{{
                                'form.order-type.internal-transfer'|translate }}</ng-container>
                            <ng-container *ngSwitchCase="OrderType.REFUND">{{ 'form.order-type.refund'|translate
                                }}</ng-container>
                            <ng-container *ngSwitchCase="OrderType.REFUND_PERIOD">{{
                                'form.order-type.refund-period'|translate }}</ng-container>
                            <ng-container *ngSwitchCase="OrderType.SUBSCRIPTION">{{
                                'form.order-type.subscription'|translate }}</ng-container>
                            <ng-container *ngSwitchCase="OrderType.SUBSCRIPTION_PERIOD">{{
                                'form.order-type.subscription-period'|translate }}</ng-container>
                        </h2>
                    </div>
                    <div class="col-12 col-sm-7 mt-3 mt-sm-0">
                        <label>{{ 'product.name'|translate }}</label>
                        <h2 class="mat-title text-blue font-weight-bold mb-0">{{ selectedProduct.name }}</h2>
                    </div>
                </div>
                <hr class="mt-3 mb-5" />

                <form #formMeetingSign="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <mat-label>{{ 'operative.date-time-meeting' | translate }}</mat-label>
                                <input matInput type="datetime-local" required
                                    [placeholder]="'form.hints.date-time' | translate" class="dateTimePicker"
                                    #dateCtrl="ngModel" (ngModel)="selectedProduct.meetingDetails.date" name="msDate"
                                    [dateTimeFuture] (change)="onChangeDate($event.target.value)" />

                                <mat-error *ngIf="dateCtrl.hasError('required')">
                                    {{ 'form.validation.required' | translate }}
                                </mat-error>
                                <mat-error *ngIf="dateCtrl.hasError('dateTimeFuture')">
                                    {{ 'form.validation.pastTime' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <input name="msPlace" matInput [placeholder]="'operative.place-meeting' | translate"
                                    [disabled]="isDisabled" required #placeCtrl="ngModel"
                                    (ngModel)="selectedProduct.meetingDetails.place"
                                    (change)="onChangePlace($event.target.value)"
                                    maxlength="25" />
                                <mat-error *ngIf="placeCtrl.hasError('required')">
                                    {{ 'form.validation.required' | translate }}
                                </mat-error>

                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <label class="pb-30">{{ 'operative.meeting-attendees' | translate }}</label>
                            <br>
                            <div *ngFor="let participant of participants | orderBy:'name'">
                                <mat-checkbox class="sign" name="msAssistants" [value]="participant.clientId"
                                    (change)="assistantsToggleCheckbox($event,participant)" ngModel >
                                    {{participant.name}} {{participant.surname}}
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <label class="pb-30">{{ 'operative.meeting-initiator' | translate }}</label>
                            <div>
                                <mat-checkbox class="sign" name="msAgent" [value]="agentUserId"
                                    (change)="agentToggleCheckbox($event)" ngModel >
                                    {{agentName}} {{agentSurname}}
                                </mat-checkbox>
                            </div>
                            <div *ngFor="let participant of participants | orderBy:'name'">
                                <mat-checkbox class="sign" name="msInitiator" [value]="participant.clientId"
                                    (change)="initiatorsToggleCheckbox($event, participant)" ngModel >
                                    {{participant.name}} {{participant.surname}}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <textarea matInput name="msNotes" [placeholder]="'operative.meeting-notes' | translate"
                                    [disabled]="isDisabled" required maxlength="500"
                                    (change)="onChangeNotes($event.target.value)" #notesCtrl="ngModel"
                                    cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                                    cdkAutosizeMaxRows="7" (ngModel)="selectedProduct.meetingDetails.notes">
                                    </textarea>
                                <mat-error *ngIf="notesCtrl.hasError('required')">
                                    {{ 'form.validation.required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row justify-content-between mb-5">
                        <div class="col-12 col-sm-6 col-md-4">
                            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray"
                                (click)="onCancel()">
                                {{ 'general.cancel'|translate }}
                            </button>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!formMeetingSign.valid || !allInitiators ||!checkedAssistants">
                                {{ 'general.continue-sign'|translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</main>
